import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnDestroy, OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {TeacherDashboardBlockEmptyData} from "../../interfaces/teacher-dashboard-block-empty-data";

@Component({
  selector: 'brt-teacher-dashboard-block',
  templateUrl: './teacher-dashboard-block.component.html',
  styleUrls: ['./teacher-dashboard-block.component.scss']
})
export class TeacherDashboardBlockComponent implements OnDestroy {

  @ViewChild('projectedContent') set setProjectedContent(val: ElementRef) {
    const htmlEl = val.nativeElement as HTMLElement;
    this.hasProjectedContent = this.elHasProjectedContent(htmlEl);

    this.mutationObserver = new MutationObserver((mutations) => {

      mutations.forEach((mutation) => {
        this.onProjectedContentChildListChanged(mutation);
      });
    });

    this.mutationObserver.observe(val.nativeElement, {
      attributes: false,
      childList: true,
      characterData: false
    });
  }

  @Input('useOwnTemplate') useOwnTemplate: boolean = false;
  @Input('headlineData') headlineData!: Partial<DashboardBoxesHeadData>;
  @Input('empty-data') emptyData?: TeacherDashboardBlockEmptyData;

  @Input('actionButtonLabel') actionButtonLabel!: string;
  @Output('actionButtonClicked') onActionButtonClicked = new EventEmitter();
  @Input('theme') theme: "default"| "quest" = "default";
  @Input('hasFooter') hasFooter = true;

  mutationObserver?: MutationObserver;
  hasProjectedContent = false;




  onProjectedContentChildListChanged(record: MutationRecord): void {
    // console.log(record);
    if(record.type === "childList") {
      this.hasProjectedContent = this.elHasProjectedContent(record.target);
    }
  }

  ngOnDestroy() {
    if(this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  elHasProjectedContent(node: Node): boolean {

    const children = node.childNodes;
    let numberOfFilteredNodes = 0;
    children.forEach((el) => {
      if(el.nodeType !== Node.COMMENT_NODE) {
        numberOfFilteredNodes++;
      }
    })

    return numberOfFilteredNodes > 0;
  }

  getHasFooter() {
    return (this.actionButtonLabel && this.hasProjectedContent) || (this.emptyData && !this.hasProjectedContent && this.emptyData.buttonCallback && this.emptyData.buttonLabel) || false;
  }
}
